/**
 * Deep-linkable steps for the guided import, mirroring EventImportsPreview:
 * `?step=template|upload|confirm`, or the 1-based number.
 */
export const STEP_SLUGS = ['template', 'upload', 'confirm'] as const

export type StepSlug = (typeof STEP_SLUGS)[number]

export function readStepParam(search = window.location.search): number {
  try {
    const raw = new URLSearchParams(search).get('step')
    if (!raw) return 0

    const bySlug = STEP_SLUGS.indexOf(raw.toLowerCase() as StepSlug)
    if (bySlug !== -1) return bySlug

    const byNumber = Number.parseInt(raw, 10) - 1
    return byNumber >= 0 && byNumber < STEP_SLUGS.length ? byNumber : 0
  } catch {
    return 0
  }
}

export function writeStepParam(step: number) {
  try {
    const url = new URL(window.location.href)
    url.searchParams.set('step', STEP_SLUGS[step])
    window.history.replaceState({}, '', url)
  } catch {
    // no-op outside the browser
  }
}
